import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';
import { Navigate } from 'react-router-dom';

export const adminRoutes: RouteConfig[] = [
  {
    path: '/admin',
    element: <Navigate to="/admin/dashboard" replace />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: false,
  },
  {
    path: '/admin/dashboard',
    element: <Components.AdminDashboardPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/tenants',
    element: <Components.TenantsPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/tenants/create',
    element: <Components.CreateTenantPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/tenants/edit/:id',
    element: <Components.EditTenantPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/tenants/trash',
    element: <Components.TenantsTrashPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/tenants/:tenantId/users',
    element: <Components.TenantUsersPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/users',
    element: <Components.UsersManagementPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/users/tenant/:id',
    element: <Components.TenantUsersPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/verification/pending',
    element: <Components.VerificationPendingPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/users-actions',
    element: <Components.UsersAdminActionsPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/plans',
    element: <Navigate to="/admin/subscription-policies?tab=plans" replace />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: false,
  },
  {
    path: '/admin/plans/create',
    element: <Components.CreatePlanPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/plans/edit/:id',
    element: <Components.EditPlanPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/subscription-policies/plans/create',
    element: <Components.CreatePlanPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/subscription-policies/plans/edit/:id',
    element: <Components.EditPlanPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/modules',
    element: <Components.ModulesPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/modules/create',
    element: <Components.CreateModulePage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/modules/:id/edit',
    element: <Components.EditModulePage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/modules/:id/permissions',
    element: <Components.ModulePermissionsPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
    {
      path: '/admin/modules/categories',
      element: <Components.CategoriesTablePage />,
      roles: ['SUPER_ADMIN'],
      requiresAuth: true,
      requiresLayout: true,
    },
  {
    path: '/admin/integrations',
    element: <Components.IntegrationsPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/profile',
    element: <Components.ProfilePage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // WebPage Module Routes
  {
    path: '/admin/webpage',
    element: <Components.WebpageDashboardPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/list',
    element: <Components.WebpageListPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/builder',
    element: <Components.WebpageBuilderPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/builder/:id',
    element: <Components.WebpageBuilderPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/edit',
    element: <Components.WebpageEditPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/edit/:id',
    element: <Components.WebpageEditPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/preview/:id',
    element: <Components.WebpagePreviewPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/preview/slug/:slug',
    element: <Components.WebpagePreviewPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/gallery',
    element: <Components.WebpageTemplateGallery />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/templates',
    element: <Components.WebpageTemplateGallery />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/template-preview/:id',
    element: <Components.WebpageTemplatePreviewPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/webpage/template-edit/:id',
    element: <Components.WebpageTemplateEditPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/billing',
    element: <Components.BillingPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/billing/create',
    element: <Components.CreateInvoicePage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/billing/automatic',
    element: <Components.ScheduledInvoicesPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/billing/testing',
    element: <Components.InvoiceGenerationTestingPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/platform-billing',
    element: <Components.PlatformBillingPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/subscription-policies',
    element: <Components.SubscriptionPoliciesPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/subscription-policies/create',
    element: <Components.CreateSubscriptionPolicyPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/subscription-policies/edit/:id',
    element: <Components.EditPolicyPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/contactos',
    element: <Components.ContactsPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/inbox',
    element: <Components.InboxPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/system',
    element: <Components.SystemPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/configuracion',
    element: <Components.AdminSettingsPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Email Templates
  {
    path: '/admin/email-templates',
    element: <Components.EmailTemplatesPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // API Keys
  {
    path: '/admin/api-keys',
    element: <Components.ApiKeysPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // Admin UI P1 (Gabriel backlog) — Subscriptions / AuditEvents / ErpMetrics
  {
    path: '/admin/subscriptions',
    element: <Components.AdminSubscriptionsPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/admin/audit-events',
    element: <Components.AdminAuditEventsPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  // GH#2692 — `/admin/erp-metrics` NO se monta: la pantalla pide `GET /admin/erp-metrics/summary` y `/monthly`, que el API no tiene (404
  // medido en producción el 13-oct), y no hay a qué apuntarla: pinta un P&L (ingresos, gastos, neto) y las 10 rutas que sí existen
  // son métricas de plataforma. Sin entrada de menú ni enlace, esconderla no quita nada. Los archivos de la pantalla y su cliente
  // se quedan. Cuando BACKEND construya `summary` y `monthly`: volver a montar esta ruta y quitar `adminRoutes.erp-metrics.gh2692.test.ts`.
  // Trust Badge — SUPER_ADMIN review queue (approve/reject pending requests)
  {
    path: '/admin/trust-badge/review',
    element: <Components.TrustBadgeAdminReviewPage />,
    roles: ['SUPER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
];

// NOTA (2026-05-25): la entry /admin/erp de la iteracion anterior fue
// movida a `routes/erpRoutes.tsx` con path `/erp/dashboard` segun la
// decision arquitectonica corregida (TINA + Randhy) para evitar mezclar
// el nuevo feature `features/erp/` con la deuda legacy de `agency/erp`.
